import { useContext } from 'react';
import PDPStickyButtonsContext from './PDPStickyButtonsContext';
const noop = () => {};
const usePdpSetShowStickyButtons = () => {
  return useContext(PDPStickyButtonsContext)?.setShowStickyButtons ?? noop;
};
export default usePdpSetShowStickyButtons;